<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import ButtonBack from '../../shared/ButtonBack.svelte';
    import InputEmail from '../../shared/InputEmail.svelte';
    import InputPassword from '../../shared/InputPassword.svelte';

    export let isOpen: boolean = true;
    export let text: string = '';
    export let error: string = '';

    export let onLogin: (credentials: any) => Promise<boolean|string> = async function(credentials: any) { return true };
    export let onCancel: () => void = () => {};

    let loginInput: HTMLInputElement;
    let passwordInput: HTMLInputElement;

    let login: string = '';
    let password: string = '';
    let validPassword: boolean = false;

    function onEmailValidate(valid: boolean, dirty: boolean) {
        validPassword = valid;
    }

    function onKeyUp(ev: any) {
        if (ev.key == 'Enter') {
            signIn();
        }
    }

    async function signIn() {
        if (login && password && validPassword) {
            let logged = await onLogin({login: login, password: password})
            if (logged === true) {
                closeModal();
            } else if (typeof(logged) == 'string') {
                error = logged;
            }
        }
    }

    $: {
        login = login;
        password = password;
        validPassword = validPassword;
        console.log('??? credentials', login, password);
    }
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <h3 style="text-align: center;">{@html text}</h3>

            {#if error != ''}
                <div class="error">{@html error}</div>
            {/if}

            <div>
                <InputEmail bind:value={login} placeholder="E-mail" style="border: 1px solid #ccc; width: 100%" onValidation={onEmailValidate} on:keyup={onKeyUp}/>
            </div>
            <div style="margin-top: 5px">
                <InputPassword bind:value={password} placeholder={$_('password')} style="border: 1px solid #ccc; width: 100%" on:keyup={onKeyUp}/>
            </div>

            <div class="actions">
                <ButtonBack
                    text={$_('Cancel')}
                    on:click={() => {
                        closeModal();
                        onCancel();
                    }}
                />
                <ButtonMain
                    text={$_('OK')}
                    disabled={(!login || !password || !validPassword)}
                    on:click={signIn}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 390px;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        border: 3px solid var(--automapa-blue);
        box-shadow:
            0 0 0 10px #1c5dc722,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        column-gap: 10px;
    }

    .error {
        color: var(--automapa-red);
        margin-bottom: 10px;
    }
</style>
